import { isPiPath } from './piAvailability.js';

export const UNLOCK_KEY = 'pi:unlock';
export const UNLOCK_TTL_MS = 30 * 24 * 60 * 60 * 1000;
export const UNLOCK_PATH = '/product-intelligence/desbloquear';

const PASSWORD_HASH = 'e66caf83';

const fingerprint = (text) => {
  let hash = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return ('0000000' + hash.toString(16)).slice(-8);
};

const ownerOf = (storage) => {
  try {
    const info = JSON.parse(storage.getItem('mamUserMasterInfo') || 'null');
    return info && info.id ? String(info.id) : '';
  } catch (error) {
    return '';
  }
};

export const passwordMatches = (password) => typeof password === 'string' && password !== '' && fingerprint(password) === PASSWORD_HASH;

export const isUnlocked = (storage, now) => {
  if (!storage) return false;
  try {
    const record = JSON.parse(storage.getItem(UNLOCK_KEY) || 'null');
    if (!record || typeof record.until !== 'number' || record.until <= now) return false;
    return (record.owner || '') === ownerOf(storage);
  } catch (error) {
    return false;
  }
};

export const unlock = (storage, password, now) => {
  if (!passwordMatches(password)) return false;
  try {
    storage.setItem(UNLOCK_KEY, JSON.stringify({ until: now + UNLOCK_TTL_MS, owner: ownerOf(storage) }));
  } catch (error) {
    return true;
  }
  return true;
};

export const browserStorage = () => {
  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
};

const isUnlockPath = (path) => path.toLowerCase().indexOf(UNLOCK_PATH) === 0;

export const needsUnlock = (path, storage, now) =>
  isPiPath(path)
  && !isUnlockPath(path)
  && !isUnlocked(storage, now);

export const safeRedirect = (value) => {
  const text = typeof value === 'string' ? value : '';
  return isPiPath(text) && !isUnlockPath(text) && text.indexOf('//') === -1
    ? text
    : '/product-intelligence';
};



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/piUnlock.js